import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function HitIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7197 3.70182L15.8895 9.52267L12.7081 12.7134C12.5181 12.8971
        12.2642 12.9998 12 12.9998C11.7357 12.9998 11.4818 12.8971 11.2918
        12.7134L11.288 12.7096C11.1008 12.5206 10.9957 12.2653 10.9957
        11.9993C10.9957 11.7332 11.1008 11.478 11.288 11.289L11.2891
        11.2878L13.6694 8.91606C13.0682 8.58653 12.3816 8.4387 11.6938
        8.49446C10.9032 8.55856 10.1575 8.88789 9.57754 9.42902C8.99762
        9.97016 8.61754 10.6913 8.49895 11.4756C8.38036 12.2599 8.53022
        13.0612 8.92423 13.7496C9.31823 14.438 9.93326 14.9731 10.6696
        15.2681C11.4058 15.5631 12.2202 15.6006 12.9805 15.3747C13.7408
        15.1487 14.4025 14.6725 14.8582 14.0233C15.3139 13.3741 15.5369
        12.59 15.491 11.7981L15.4909 11.7964C15.4842 11.6651 15.5034
        11.5337 15.5476 11.4098C15.5917 11.2859 15.6598 11.1719 15.7481
        11.0743C15.8363 10.9768 15.9429 10.8976 16.0618 10.8414C16.1801
        10.7854 16.3083 10.7532 16.439 10.7465C16.5695 10.7384 16.7003
        10.7561 16.8239 10.7988C16.9481 10.8416 17.0626 10.9088 17.1606
        10.9963C17.2586 11.0838 17.3383 11.19 17.3949 11.3086C17.4513
        11.4268 17.4837 11.5551 17.4902 11.6859C17.5631 12.9356 17.2074
        14.1728 16.482 15.193C15.7564 16.2136 14.7042 16.956 13.4994
        17.2975C12.2946 17.639 11.0093 17.5591 9.85609 17.0711C8.70284
        16.5831 7.75066 15.7161 7.15696 14.6135C6.56326 13.511 6.3636 12.2388
        6.59097 11.0073C6.81835 9.77589 7.45915 8.65891 8.40744 7.84104C9.35573
        7.02317 10.5547 6.5534 11.8062 6.50938C12.9853 6.46791 14.1444
        6.80669 15.1137 7.47257L16.9043 5.68205C15.4244 4.53413 13.5854
        3.94067 11.708 4.01095C9.73902 4.08465 7.86672 4.88322 6.45068
        6.25326C5.03464 7.6233 4.17471 9.46822 4.03606 11.4337C3.8974
        13.3991 4.48979 15.3465 5.69945 16.9018C6.90911 18.457 8.65075
        19.5105 10.5898 19.86C12.5289 20.2094 14.5288 19.83 16.2052
        18.7948C17.8817 17.7596 19.1165 16.1415 19.6726 14.2512C20.2287 12.361 20.0667 10.3317 19.218
        8.55357C19.1037 8.31344 19.0895 8.03774 19.1785 7.78714C19.2675 7.53654 19.4524 7.33155 19.6925
        7.21728C19.9327 7.10301 20.2084 7.08881 20.459 7.17781C20.7096 7.26681 20.9146 7.45172 21.0288
        7.69185C21.9176 9.55808 22.2062 11.6539 21.8549 13.6909C21.5037 15.7278 20.5299 17.6058 19.0674
        19.0666C18.1403 19.9963 17.0388 20.734 15.826 21.2373C14.6133 21.7406 13.3131 21.9997 12 21.9997C10.6869
        21.9997 9.38666 21.7406 8.17387 21.2373C6.96107 20.7339 5.85952 19.9962 4.93231 19.0664C4.00275 18.1393
        3.26521 17.0379 2.76196 15.8254C2.25861 14.6126 1.99951 13.3124 1.99951 11.9993C1.99951 10.6862 2.25861
        9.38598 2.76196 8.17318C3.26527 6.96048 4.0029 5.859 4.9326 4.93183C6.71302 3.14996 9.10032 2.10563 11.6173
        2.00758C14.057 1.91255 16.4444 2.71334 18.3314 4.25423L20.2973 2.27962L20.307 2.27165C20.5007 2.11268 20.7466
        2.03144 20.9969 2.04373C21.2471 2.05602 21.4839 2.16097 21.6611 2.33815C21.8383 2.51534 21.9432 2.7521
        21.9555 3.00238C21.9678 3.25265 21.8866 3.49856 21.7276 3.69225L21.7197 3.70182Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
